const translationKeys = {
  insurance_agreements_list_header_title:
    'insurance_agreements_list_header_title',
  insurance_agreements_list_header_description:
    'insurance_agreements_list_header_description',
  insurance_agreements_list_error_title:
    'insurance_agreements_list_error_title',
  insurance_agreements_list_error_message:
    'insurance_agreements_list_error_message',
  insurance_agreements_list_no_data_title:
    'insurance_agreements_list_no_data_title',
  insurance_agreements_list_no_data_message:
    'insurance_agreements_list_no_data_message',
  insurance_agreements_list_no_data_button:
    'insurance_agreements_list_no_data_button',
  insurance_agreements_list_no_data_graphic_alt_text:
    'insurance_agreements_list_no_data_graphic_alt_text',
  insurance_agreements_list_renewed_agreement_message:
    'insurance_agreements_list_renewed_agreement_message',
  insurance_agreements_list_user_claims_title:
    'insurance_agreements_list_user_claims_title',
  insurance_agreements_list_user_claims_message:
    'insurance_agreements_list_user_claims_message',
  insurance_agreement_details_make_claim_button:
    'insurance_agreement_details_make_claim_button',
  insurance_agreement_details_about_section_title:
    'insurance_agreement_details_about_section_title',
  insurance_agreement_details_about_valid_from_label:
    'insurance_agreement_details_about_valid_from_label',
  insurance_agreement_details_about_valid_until_label:
    'insurance_agreement_details_about_valid_until_label',
  insurance_agreement_details_about_coverage_label:
    'insurance_agreement_details_about_coverage_label',
  insurance_agreement_details_about_agreement_number_label:
    'insurance_agreement_details_about_agreement_number_label',
  insurance_agreement_details_error_try_again_button:
    'insurance_agreement_details_error_try_again_button',
  insurance_agreement_details_error_title:
    'insurance_agreement_details_error_title',
  insurance_agreement_details_error_message:
    'insurance_agreement_details_error_message',
  insurance_agreement_details_document_section_title:
    'insurance_agreement_details_document_section_title',
  insurance_agreement_details_document_certificate_and_terms_label:
    'insurance_agreement_details_document_certificate_and_terms_label',
  insurance_agreement_details_cost_section_title:
    'insurance_agreement_details_cost_section_title',
  insurance_agreement_details_cost_yearly_fee_label:
    'insurance_agreement_details_cost_yearly_fee_label',
  insurance_agreement_details_cost_yearly_fee_with_motor_tax_info_message:
    'insurance_agreement_details_cost_yearly_fee_with_motor_tax_info_message',
  insurance_agreement_details_cost_billing_interval_label:
    'insurance_agreement_details_cost_billing_interval_label',
  insurance_agreement_details_cost_billing_interval_halfyearly_label:
    'insurance_agreement_details_cost_billing_interval_halfyearly_label',
  insurance_agreement_details_cost_billing_interval_monthly_label:
    'insurance_agreement_details_cost_billing_interval_monthly_label',
  insurance_agreement_details_cost_billing_interval_quarterly_label:
    'insurance_agreement_details_cost_billing_interval_quarterly_label',
  insurance_agreement_details_cost_billing_interval_yearly_label:
    'insurance_agreement_details_cost_billing_interval_yearly_label',
  insurance_agreement_details_cost_prices_period_message:
    'insurance_agreement_details_cost_prices_period_message',
  insurance_agreement_details_cost_price_per_month_label:
    'insurance_agreement_details_cost_price_per_month_label',
  insurance_agreement_details_cost_price_per_quarter_label:
    'insurance_agreement_details_cost_price_per_quarter_label',
  insurance_agreement_details_cost_price_per_halfyear_label:
    'insurance_agreement_details_cost_price_per_halfyear_label',
  insurance_agreement_details_cost_price_per_halfyear_info_message:
    'insurance_agreement_details_cost_price_per_halfyear_info_message',
  insurance_agreement_details_cost_price_per_month_info_message:
    'insurance_agreement_details_cost_price_per_month_info_message',
  insurance_agreement_details_cost_price_per_quarter_info_message:
    'insurance_agreement_details_cost_price_per_quarter_info_message',
  insurance_agreement_details_insured_object_number_label:
    'insurance_agreement_details_insured_object_number_label',
  insurance_breadcrumb_insurances_overview:
    'insurance_breadcrumb_insurances_overview',
  insurance_agreements_list_vehicle_section_title:
    'insurance_agreements_list_vehicle_section_title',
  insurance_agreements_list_life_and_health_section_title:
    'insurance_agreements_list_life_and_health_section_title',
  insurance_agreements_list_property_section_title:
    'insurance_agreements_list_property_section_title',
  insurance_agreements_list_animal_section_title:
    'insurance_agreements_list_animal_section_title',
  insurance_agreements_list_travel_section_title:
    'insurance_agreements_list_travel_section_title',
  insurance_agreement_details_compare_agreements_section_title:
    'insurance_agreement_details_compare_agreements_section_title',
  insurance_agreement_details_compare_agreements_section_button:
    'insurance_agreement_details_compare_agreements_section_button',
  insurance_agreement_details_renewed_agreement_previous_value_label:
    'insurance_agreement_details_renewed_agreement_previous_value_label',
  insurance_agreement_details_document_certificate_and_terms_download_error_message:
    'insurance_agreement_details_document_certificate_and_terms_download_error_message',
};

Object.freeze(translationKeys);

export default translationKeys;
